/** @jsx jsx */
import React from 'react';
import { utilityColor } from 'components/styles';
import FormContents from 'components/atoms/Form/FormContents';
import FormField from 'components/atoms/Form/FormField';
import FormSubmitArea from 'components/atoms/Form/FormSubmitArea';
import PrimaryButton from 'components/atoms/Button';
import RadioSelector from 'components/molecules/RadioSelector';
import FileSelectButton from 'components/molecules/FileSelectButton';
import BodyText from 'components/atoms/BodyText';
import { Row, Col } from 'react-grid-system';
import FormPadding from 'components/atoms/Form/FormPadding';
import TabControl from 'components/atoms/TabControl';
import Warning from 'components/atoms/Icon/Warning';
import { Link } from 'react-router-dom';
import BlockUI from 'components/molecules/BlockUi';
import ConfirmActionModal, { ActionType } from 'components/organismos/ConfirmActionModal';
import { useOrganizationCsvForm } from './hooks';
import { css, jsx } from '@emotion/core';
import DataTable from 'components/organismos/DataTable/DataTable';
import moment from 'moment';
import { grayScale } from 'components/styles';
import LableTitle from 'components/atoms/LableTitle';
import FormHeader from 'components/templates/FormHeader';
const isIpad = window.matchMedia("(max-width: 1024px)").matches;

export type UploadType = 'organization' | 'manager' | 'specialday';

type SelectType = 'csv'|'csvHistory';
const SelectType: {[key in SelectType]: SelectType} = {
  csv: 'csv',
  csvHistory: 'csvHistory'
};

const styles = {
  table: css`
    table th:nth-of-type(1) {
      width: ${isIpad ? '15%' : '12%'};
    }
    table th:nth-of-type(2) {
      width: ${isIpad ? '15%' : '20%'};
    }
    table th:nth-of-type(3) {
      width: ${isIpad ? '12%' : '10%'};
    }
    table th:nth-of-type(4) {
      width: ${isIpad ? '28%' : '30%'};
    }
    table th:nth-of-type(5) {
      width: ${isIpad ? '15%' : '8%'};
    }
    table td:nth-of-type(5) {
      text-align: center;
    }
    table th:nth-of-type(6) {
      width: ${isIpad ? '15%' : '20%'};
    }
    .svg-red path:last-child {
      fill: red;
    } 
  `,
};

const OrganizationCsvAddForm: React.FC = () => {
  const {
    uploadType, setUploadType, uploadTypeItems, uploadFile, setUploadFile, onSubmit,
    errors, blocking,
    confirmModalOpen, closeConfirmModal, importHistory
  } = useOrganizationCsvForm();
  const [selectType, setSelectType] = React.useState<SelectType>(SelectType.csv);
  const columns = React.useMemo(
    () => [
      {
        Header: () => 'データ種別',
        id: 'formatType',
        accessor: 'formatType',
        Cell: (cell: {
          row: { isExpanded: boolean; original: any; index: number };
          data: any;
        }) => (
          <div style={{ textAlign: 'center' }}>
            {cell.row.original.formatType === 0 ? '組織情報' : cell.row.original.formatType === 1 ? 'マネージャー権限' : '特賃日割当情報'}
          </div>
        ),
      },
      {
        Header: 'ファイル名',
        accessor: 'importFileName',
      },
      {
        Header: () => '処理結果',
        id: 'result',
        accessor: 'result',
        Cell: (cell: { row :{ isExpanded: boolean, original: any }}) => (
          <div
              style={{ textAlign: 'center' }}
              className={`svg-${
                cell.row.original.result === 1 && 'red'
              }`}
            >
            { cell.row.original.result === 1 && <Warning />  }
            <span style={{ marginTop: '-3px', marginLeft: '3px' }}>{ cell.row.original.result === 1 ? '失敗': '成功' }</span>
          </div>
        ),
      },
      {
        Header: 'エラー内容',
        accessor: 'errDetailDisp',
      },
      {
        Header: '実施日時',
        accessor: 'updateDate',
        Cell: (cell: { row :{ isExpanded: boolean, original: any }}) => (
          <div>
            { moment(cell.row.original.updateDate).format('YYYY/MM/DD') } <br/>
            <span style={{ color: grayScale.gray50 }}>{ moment(cell.row.original.updateDate).format('H:m:s') }</span>
          </div>
        ),
      },
      {
        Header: '実施者',
        accessor: 'updateUser',
      },
    ],
    [],
  );

  return (
    <BlockUI blocking={blocking}>
      <FormHeader title="組織インポート" />
      <FormContents customStyle={css({marginTop:'60px'})}>
      <FormPadding >
        <Row>
          <Col md={6} xs={12}>
            <TabControl
              items={[
                {
                  value: SelectType.csv,
                  display: 'インポート',
                },
                {
                  value: SelectType.csvHistory,
                  display: '履歴参照',
                },
                // {
                //   value: SelectType.specialSalary,
                //   display: '特賃日割当情報',
                // },
              ]}
              setValue={setSelectType as (arg: string) => void}
              currentValue={selectType}
              isFixed={false}
              customStyle={css({paddingLeft:'0'})}
            />
          </Col>
        </Row>
      </FormPadding>
      {selectType === SelectType.csv
              && (
        <div>
            <FormPadding>
            <LableTitle 
              title="データ種別"          
              customStyle={css({margin: '0px', paddingLeft:'0'})}
            />

            <FormField>
              <RadioSelector
                name="uploadType"
                items={uploadTypeItems}
                value={uploadType}
                setValue={(
                  e: React.ChangeEvent<HTMLInputElement>,
                ) => setUploadType(e.target.value as UploadType)}
              />
            </FormField>

            {/* <FormField>
              {uploadTypeItems.find((item) => item.value === uploadType)?.label}
              の最終アップロード
            </FormField> */}

            <Row>
              <FormField customStyle={css({ margin: '0 auto' })}>
                <FileSelectButton
                  customStyle={css({ padding: '30px 90px' })}
                  text="CSVファイルをアップロード"
                  ghost={true}
                  setFile={setUploadFile}
                  accept="text/csv,.csv,application/vnd.ms-excel"
                />
              </FormField>
            </Row>
            <Row>
              <BodyText color={utilityColor.error} size="md" customStyle={css({ margin: '0 auto', fontSize: '14px' })}>CSVファイルの1行目（ヘッダー行）はインポートされません。</BodyText>
            </Row>
            {uploadFile || errors
              ? (
                <FormField
                  displayBlock={true}
                >
                  <div>
                    {uploadFile?.name}
                  </div>
                  {errors && errors.map((error) => (
                    <div key={error}>
                      <BodyText color={utilityColor.error}>
                        {error}
                      </BodyText>
                    </div>
                  ))}
                </FormField>
              )
              : null}

            <FormSubmitArea customStyle={css({ textAlign: 'center', margin: '30px 0 15px' })}>
              <PrimaryButton
                text="インポート"
                onClick={onSubmit}
                disabled={!uploadFile}
              />
              <FormField
                  displayBlock={true}
                >
                <Link to="/organizations">
                  <PrimaryButton
                    text="戻る"
                    ghost={true}
                  />
                </Link>
              </FormField>
            </FormSubmitArea>
            </FormPadding>
        </div>
        )}
        {selectType === SelectType.csvHistory
          && (

          <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', marginTop: '15px', paddingBottom: '15px' }}>
            <div className="table-bordered table-padding" css={styles.table}>
            <DataTable 
              classNameParrant="border-left-right"
              className="table-no-border-left-right" 
              iconSize="16px" 
              // globalSearchStyle={css({ marginLeft: '20px' })} 
              columns={columns} data={importHistory} 
              isGlobalFilter={true} 
              // minWidth="1600px"
              />
            </div>
          </div>
          
        )}
      </FormContents>
      <ConfirmActionModal
        open={confirmModalOpen}
        closeHandler={closeConfirmModal}
        onSubmit={onSubmit}
        actionType={ActionType.IMPORT}
      />
    </BlockUI>
  );
};

export default OrganizationCsvAddForm;
